export const CharacterSkins = {
  Grizzly: 'grizz',
  Panda: 'panda',
  Ice: 'ice'
} as const;
export type CharacterSkinsKeys = keyof typeof CharacterSkins;
export type CharacterSkinsValues = typeof CharacterSkins[CharacterSkinsKeys];

export const CharacterAnimation = {
  Static: 'static',
  Run: 'run',
  RunSmash: 'run-smash',
  Jump: 'jump',
  Fall: 'fall',
  Glide: 'glide',
  Death: 'death'
} as const;

export const CharacterState = {
  Idle: 'idle',
  Running: 'running',
  RunSmashing: 'smashing',
  Jumping: 'jumping',
  Falling: 'falling',
  Gliding: 'gliding',
  Dead: 'dead'
} as const;

export type CharacterStateKeys = keyof typeof CharacterState;
export type CharacterStateValues = typeof CharacterState[CharacterStateKeys];

// Types aren't correct - https://github.com/photonstorm/phaser/issues/5463
export default class CharacterSpine extends window.SpinePlugin.SpineGameObject {
  public static events = {
    StopCharacter: 'stopCharacter'
  } as const;

  protected skins: CharacterSkinsValues[];
  protected currentSkinIndex: number;
  protected isMoving: boolean;
  protected smashTime: number;
  protected currentState: CharacterStateValues;

  constructor(scene: Phaser.Scene, x: number, y: number, skin: CharacterSkinsValues) {
    super(scene, scene.sys.spine, x, y, 'bear', CharacterAnimation.Static, true);

    this.skins = Object.values(CharacterSkins);
    this.currentSkinIndex = this.skins.indexOf(skin);
    this.setSkinByName(skin);
    this.scale = 0.35;

    this.isMoving = false;
    this.smashTime = 1000;
    this.currentState = CharacterState.Idle;

    // this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.update, this);
    this.on(Phaser.GameObjects.Events.DESTROY, () => {
      // this.scene.events.off(Phaser.Scenes.Events.UPDATE, this.update, this);
      // this.destroy();
    });

    this.preMultipliedAlpha = true;
    // this.scene.events.once(CharacterSpine.events.StopCharacter, this.stopMoving, this);
  }

  get CurrentSkin() {
    return this.skins[this.currentSkinIndex % this.skins.length];
  }

  public switchCharacter() {
    this.currentSkinIndex++;
    this.setSkinByName(this.skins[this.currentSkinIndex % this.skins.length]);
  }

  public startMoving() {
    this.isMoving = true;

    this.run();
    // this.once('end', () => {
    //   this.addAnimation(0, CharacterAnimations.Static, true);
    //   this.isMoving = true;
    // });
  }

  public stopMoving() {
    this.isMoving = false;
    this.setAnimation(0, CharacterAnimation.Static, true);
  }

  public startSmash() {
    this.runSmash();
  }

  public endSmash() {
    if (this.currentState == CharacterState.RunSmashing) {
      this.run();
    }
  }

  public startJump() {
    this.jump();
  }

  public land() {
    if (this.isMoving) {
      if (this.currentState != CharacterState.Running) this.run();
    } else this.setAnimation(0, CharacterAnimation.Static, true);
  }

  // #region animations

  public run() {
    this.currentState = CharacterState.Running;
    this.setAnimation(0, CharacterAnimation.Run, true);
  }

  public runSmash() {
    this.currentState = CharacterState.RunSmashing;
    this.setAnimation(0, CharacterAnimation.RunSmash, true);
  }

  public jump() {
    this.currentState = CharacterState.Jumping;
    this.setAnimation(0, CharacterAnimation.Jump, false);
  }

  public gliding() {
    this.currentState = CharacterState.Gliding;
    this.setAnimation(0, CharacterAnimation.Glide, true);
  }

  public falling() {
    this.currentState = CharacterState.Falling;
    this.setAnimation(0, CharacterAnimation.Fall, false);
  }

  public die() {
    this.currentState = CharacterState.Dead;
    this.setAnimation(0, CharacterAnimation.Death, false);
  }

  // #endregion
}
